import React, { useMemo, useEffect } from 'react';
import { Box, Grid, Card, CardContent, Typography, Chip, Button, Stack, TextField } from '@mui/material';
import { motion } from 'framer-motion';
import usePortfolioStore from '../store/portfolioStore.js';
import useAuthStore from '../store/authStore.js';
import { useState } from 'react';

const skillKeywords = [
  'react', 'next', 'node', 'express', 'mongo', 'nestjs', 'asp', 'django', 'flask', 'wordpress', 'shopify', 'webflow', 'magento', 'langchain', 'n8n', 'docker', 'vercel', 'scrap', 'selenium', 'playwright', 'graphql', 'trpc', 'typescript'
];

export default function Projects() {
  const { repos } = usePortfolioStore();
  const fetchRepos = usePortfolioStore((s) => s.fetchRepos);
  const pinProject = usePortfolioStore((s) => s.pinProject);
  const unpinProject = usePortfolioStore((s) => s.unpinProject);
  const pinnedIds = usePortfolioStore((s) => s.pinnedProjectIds);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [query, setQuery] = useState('');
  useEffect(() => { if (!repos.length) fetchRepos(); }, [repos.length, fetchRepos]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return repos
      .filter(r => !q || r.name.toLowerCase().includes(q) || (r.description || '').toLowerCase().includes(q))
      .filter(r => skillKeywords.some(k => r.name.toLowerCase().includes(k) || (r.topics || []).join(' ').toLowerCase().includes(k) || (r.description || '').toLowerCase().includes(k)) || r.stars > 0);
  }, [repos, query]);

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
        <Typography variant="h5">GitHub Projects</Typography>
        <TextField size="small" placeholder="Search projects..." value={query} onChange={(e) => setQuery(e.target.value)} />
      </Stack>
      <Grid container spacing={2}>
        {filtered.map((r) => (
          <Grid item xs={12} sm={6} md={4} key={r.id}>
            <motion.div whileHover={{ y: -6, scale: 1.01 }}>
              <Card className="glass">
                <CardContent>
                  <Typography variant="h6" gutterBottom>{r.name}</Typography>
                  <Typography variant="body2" sx={{ minHeight: 48, opacity: .9 }}>{r.description || '—'}</Typography>
                  <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                    {(r.topics || []).slice(0, 3).map(t => <Chip key={t} size="small" label={t} />)}
                    {r.language && <Chip size="small" label={r.language} />}
                  </Stack>
                  <Stack direction="row" spacing={1}>
                    <Button href={r.url} target="_blank" rel="noreferrer" size="small">Repository</Button>
                    {r.homepage && <Button href={r.homepage} target="_blank" rel="noreferrer" size="small">Live</Button>}
                    {isAuthenticated && (pinnedIds.includes(r.id)
                      ? <Button size="small" color="secondary" onClick={() => unpinProject(r.id)}>Unpin</Button>
                      : <Button size="small" onClick={() => pinProject(r.id)}>Pin</Button>)}
                  </Stack>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}


